<!-- 供应链管理 -->
<script setup>
// import i18n from "@/i18n"
// import flatPickr from "vue-flatpickr-component";
import { reactive, ref } from "vue";
import { showMessage } from "@/utils/hooks/message"
import tableCom from "./components/table.vue"
import detailCom from "./detail.vue"
import { get_my_supply_chain_detail_v3 } from "@/service/apiList/supplyChain"
import { getLangValue } from "@/utils/common"; //获取后端语言
const PageHeaderT = getLangValue("menu", 'my.supply-chain')
const PageHeaderItems = [
    // {
    //     text: i18n.global.t("menu.my"),
    //     active: false,
    // },
    {
        text: getLangValue("menu", 'my.supply-chain'),
        active: true,
    },
]
const tableRef = ref(null)
const detailRef = ref(null)
const searchData = reactive({
    type: "",
    keyword: '',
    date: null,
})
const showType = ref('add')
/**
 * 搜索部分
 */
const search = () => {
    tableRef.value.searchInfo.type = searchData.type
    tableRef.value.searchInfo.keyword = searchData.keyword
    tableRef.value.searchInfo.date = searchData.date
    // if (searchData.date == '' || searchData.date == null) {
    //     tableRef.value.searchInfo.date = ''
    // } else if (!searchData.date.includes('to')) {
    //     tableRef.value.searchInfo.date = `${searchData.date} to ${searchData.date}`
    // } else {
    //     tableRef.value.searchInfo.date = searchData.date;
    // }
}

const reset = () => {
    searchData.keyword = ''
    searchData.date = null
    searchData.type = ''
    search()
}

const updateTable = () => {
    tableRef.value.getDataList()
}

const addClick = () => {
    // 添加弹框
    showType.value = 'add'
    document.getElementById('myBtnPL').click()
    detailRef.value.formData = {
        id: '',
        name: '',
        type: '',
        contacts: '',
        email: '',
        phone: '',
        description: '',
        // 供应链配置信息
        setting: [
            {
                company_name: '',
                role: [],
                contact: '',
                email: '',
            }
        ],
    }
}

const showDetails = async ({ type, info }) => {
    // 详情弹框
    showType.value = type
    const resp = await get_my_supply_chain_detail_v3(info.id)
    if (resp.code == 0) {
        let data = {
            id: info.id,
            name: resp.payload.name,
            type: resp.payload.type,
            contacts: resp.payload.contact_person,
            email: resp.payload.email,
            phone: resp.payload.contact_phone,
            description: resp.payload.description,
            disabled: resp.payload.disabled,
            setting: resp.payload.company_list.map(item => {
                return {
                    company_name: item.user_id,
                    role: item.supply_chain_role,
                    contact: item.user ? item.user.contact_first_name + ' ' + item.user.contact_last_name : '',
                    email: item.user ? item.user.contact_email : '',
                    company_name1: item.user ? item.user.company_name : ''
                }
            })
        }
        detailRef.value.formData = {
            ...data
        }
        detailRef.value.detailData = [...resp.payload.company_list.map(item => {
            return {
                label: item.user ? item.user.company_name : '',
                value: item.user_id
            }
        })]
        // console.log(detailRef.value.detailData);
        document.getElementById('myBtnPL').click()
    } else {
        showMessage('danger', resp.message)
    }
}

</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 160px);">
            <div class="w-100 h-100 bg-white  p-0" style="border-radius: 0.25rem;">
                <!-- <div class="card-title p-3 d-flex justify-content-between align-items-center"
                    style="font-size: 16px; color: #495057; font-weight: bold; border-bottom: 1px dashed #E9EBEC;">
                    {{ $t('menu.supplyChain') }}
                    <button v-permit="'my.supply-chain.add'" type="button" class="btn btn-success me-3"
                        @click="addClick()" style="min-width: 160px;">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        {{ getLangValue('my.supply-chain', "add") }}
                    </button>
                </div> -->
                <div class="p-4 d-flex justify-content-between align-items-center "
                    style="box-shadow: none; font-size: 16px; font-weight: bold; color: #495057;height: 78px;">
                    {{ getLangValue("menu", 'my.supply-chain') }}
                    <button v-permit="'my.supply-chain.add'" type="button" class="btn btn-success me-3"
                        @click="addClick()" style="min-width: 160px;">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        {{ getLangValue('my.supply-chain', "add") }}
                    </button>
                </div>
                <!-- 搜索信息 -->
                <div class="search p-4 d-flex align-items-center justify-content-between "
                    style="border-top: 1px dashed #E9EBEC;">
                    <!-- Basic example -->
                    <div class="d-flex" style="flex: 1;">
                        <div class="form-icon" style="max-width: 522px;  display: inline-block;  flex: 1;">
                            <input clearable type="text" class="form-control form-control-icon"
                                v-model="searchData.keyword" :placeholder="getLangValue('my.supply-chain', 'placeholder1')" />
                            <i class="ri-search-line"></i>
                        </div>
                        <!-- 类型 -->
                        <div class="mx-2" style=" display: inline-block;">
                            <input clearable type="text" class="form-control form-control-icon"
                                v-model="searchData.type" :placeholder="getLangValue('my.supply-chain', 'placeholder2')" />
                        </div>
                        <!-- <div class="mx-2 my-select" style="display: inline-block; height: 40px;">
                            <el-select style="width: 252px; height: 100%;" v-model="searchData.type"
                                filterable :placeholder="getLangValue('my.supply-chain', 'placeholder2')" size="large"
                                clearable>
                                <el-option v-for="item1 in databaseList" :key="item1.key" :label="item1.name"
                                    :value="item1.name">
                                </el-option>
                            </el-select>
                        </div> -->
                        <!-- 日期 -->
                        <!-- mode: 'range', -->
                        <!-- <div style="position: relative;display: inline-block;">
                            <flat-pickr style="width: 252px;display: inline-block;" v-model="searchData.date"
                                :placeholder="getLangValue('my.supply-chain', 'placeholder3')"
                                :config="{ enableTime: false, dateFormat: 'Y-m-d', mode: 'range', }"
                                class="form-control mx-2"></flat-pickr>
                            <i @click="searchData.date = ''" class="ri-close-circle-fill cursor-pointer"
                                style="position: absolute; right: 16px; top: 10px; color: #435185;"
                                v-if="searchData.date != null && searchData.date.includes('to')"></i>
                        </div> -->
                        <div class="w-10 mx-2" style="position: relative; flex: 1;">
                        <el-date-picker style="height: 37.5px;" v-model="searchData.date" type="daterange"
                            range-separator="-" :start-placeholder="$t('base.start_date')"
                            :end-placeholder="$t('base.end_date')" size="large" value-format="YYYY-MM-DD" />
                    </div>
                    </div>
                    <!-- 按钮 -->
                    <div class="d-flex justify-content-end">
                        <b-button variant="success" @click="search"
                            style="min-width: 100px; background-color: #405189; display: flex; align-items: center;border-color: unset; justify-content: center;">
                            <i class="ri-search-line me-1"></i>{{ $t('base.search') }}
                        </b-button>
                        <b-button class="mx-2" variant="success" @click="reset"
                            style="min-width: 100px;background-color: #299CDB;display: flex; align-items: center;border-color: unset; justify-content: center;">
                            <i class="ri-refresh-line me-1"></i> {{ $t('base.reset') }}
                        </b-button>
                    </div>
                </div>
                <!-- 表格数据 -->
                <tableCom ref="tableRef" @onShowDetail="showDetails" />
                <!-- 详情数据 -->
                <button type="button" class="btn btn-primary " data-bs-toggle="modal" data-bs-target="#myModal"
                    style="display: none;" id="myBtnPL"></button>
                <detailCom ref="detailRef" v-model:showType="showType" @updateTable="updateTable" />
            </div>
        </div>
    </Layout>

</template>

<style scoped>
:deep(.el-select--large .el-select__wrapper) {
    height: 37.5px;
    min-height: unset;
}
:deep(.el-date-editor .el-range-input) {
    font-size: 0.8125rem;
    color: #212529;
}

</style>
<style>
.el-date-range-picker__header button {
    margin-top: 0 !important;
}
</style>